<template>
    <el-dialog :visible.sync="visible" title="设置上级" @close="close">
        <el-form size="small" ref="formRef" :model="form" label-width="100px">
            <el-form-item
                label="上级"
                prop="leader_id"
                :rules="{
                    required: true,
                    message: '请选择上级',
                    trigger: 'blur',
                }"
            >
                <el-select
                    v-model="form.leader_id"
                    placeholder="请选择上级"
                >
                    <el-option
                        v-for="item in lists"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="handleSubmit"
                >确定</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import { apiDistributionDistributionLists, apiDistributionDistributionSetLeader } from "@/api/shop";
export default {
    data() {
        return {
            visible: false,
            id: null,
            form: {
                leader_id: ""
            },
            lists: []
        };
    },
    methods: {
        handleSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    apiDistributionDistributionSetLeader({
                        ...this.form, id: this.id
                    }).then((res) => {
                        this.visible = false;
                        this.$emit("success");
                    });
                }
            });
        },
        open(id,leader_id) {
            if(leader_id) this.form.leader_id = leader_id
            if (id) {
                this.id = id;
                apiDistributionDistributionLists({ page_type: 0 }).then(
                    (res) => {
                        this.lists = res.lists;
                        this.visible = true;
                    }
                );
            }
        },
        close() {
            this.id = null;
            this.form = {
                leader_id: ''
            };
        },
    },
};
</script>
